import KendoGantt from './KendoGantt'
import KendoGanttColumn from './KendoGanttColumn'
import KendoGanttView from './KendoGanttView'
import KendoGanttInstaller from './kendo-gantt-installer'

export { KendoGantt, KendoGantt as Gantt, KendoGanttColumn, KendoGanttColumn as GanttColumn, KendoGanttView, KendoGanttView as GanttView, KendoGanttInstaller, KendoGanttInstaller as GanttInstaller }


// WEBPACK FOOTER //
// ./packages/kendo-gantt-vue-wrapper/src/index.js